const $ = require('jquery');
global.$ = global.jQuery = $;

require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

require('bootstrap');

// Add sliderPro
require('slider-pro');
require('slider-pro/dist/css/slider-pro.min.css');

$.ajaxSetup({
  'headers': {
    'ECCUBE-CSRF-TOKEN': $('meta[name="eccube-csrf-token"]').attr('content')
  }
});
